import { Button, Link } from "@jesus-central-church/ui";
import { linkResolver, type SbButton } from "./../index";

interface SbButtonProperties {
  blok: SbButton;
}

export function ButtonComponent({ blok }: SbButtonProperties) {
  return (
    <Link href={linkResolver(blok.link)}>
      <Button
        variant={blok.variant || "primary"}
        type={blok.type || "brand-orange"}
        // eslint-disable-next-line unicorn/explicit-length-check -- blok.size is a string, not an array
        size={blok.size || "medium"}
        showArrowIcon={blok.showArrowIcon}
        className={blok.tailwindClasses || ""}
      >
        {blok.text}
      </Button>
    </Link>
  );
}
